import useDeepCompare from "@alpaca-travel/utils/use-deep-compare";
import React, { FunctionComponent, useEffect, useMemo } from "react";

import { StyleCustomisation } from "./types";
import useMapStyleStore from "./use-map-style-store";

const MapStyleCustomisation: FunctionComponent<MapStyleCustomisationProps> = ({
  customisations,
  priority = 100,
}) => {
  const latestCustomisations = useDeepCompare(customisations);
  const addStyleCustomisations = useMapStyleStore(
    (state) => state.addStyleCustomisations
  );
  const removeStyleCustomisations = useMapStyleStore(
    (state) => state.removeStyleCustomisations
  );

  const styleCustomisation = useMemo(
    (): StyleCustomisation => ({
      priority,
      customisations: latestCustomisations,
    }),
    [priority, latestCustomisations]
  );

  useEffect(() => {
    addStyleCustomisations([styleCustomisation]);
    return () => {
      removeStyleCustomisations([styleCustomisation]);
    };
  }, [styleCustomisation, addStyleCustomisations, removeStyleCustomisations]);

  return null;
};

export type MapStyleCustomisationProps = {
  customisations: StyleCustomisation["customisations"];
  priority?: number;
};

export default React.memo(MapStyleCustomisation);
